export default {
  SET_PAGES (state, pages) {
    state.pages = pages
  },

  SET_ACTIVE_PAGES (state, pages) {
    state.activePages = pages
  },

  SET_CURRENT_PAGE (state, page) {
    state.currentPage = page
  },

  SET_DEFAULT_PAGE (state, page) {
    state.defaultPage = page
  },

  SET_LOADING (state, loading) {
    state.loading = loading
  },

  ADD_PAGE (state, page) {
    if (!state.pages) {
      state.pages = { data: [], meta: { total: 0 } }
    }
    if (!state.pages.data) {
      state.pages.data = []
    }
    if (!state.pages.meta) {
      state.pages.meta = { total: 0 }
    }
    state.pages.data.unshift(page)
    state.pages.meta.total++
  },

  UPDATE_PAGE (state, updatedPage) {
    if (!state.pages || !state.pages.data) return
    const index = state.pages.data.findIndex(p => p.id === updatedPage.id)
    if (index !== -1) {
      state.pages.data.splice(index, 1, updatedPage)
    }
  },

  REMOVE_PAGE (state, id) {
    if (!state.pages || !state.pages.data || !state.pages.meta) return
    const index = state.pages.data.findIndex(p => p.id === id)
    if (index !== -1) {
      state.pages.data.splice(index, 1)
      state.pages.meta.total--
    }
  }
}
